<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline"
      @keydown.native.enter="$emit('search', formInline)">
      <el-row :gutter="0">
        <el-col :span="lg">
          <el-form-item label="批次包" label-width="68px">
            <!-- <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="请输入批次包编码"></el-input> -->
            <div @dblclick="dblclick('pkgCodeList')">
              <el-input maxlength='450' v-model="formInline.pkgCodeList" placeholder="双击批量搜索"
                @dblclick="dblclick('pkgCodeList')"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="商品SKU" label-width="68px">
            <el-input maxlength='450' v-model="formInline.shopProductSku" placeholder="请输入商品SKU"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="订单编号">
            <el-input maxlength='450' v-model="formInline.platformOrderNo" placeholder="请输入订单编号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="采购类型">
            <el-select v-model="formInline.purchaseType" placeholder="采购类型" style="width:170px">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="普通采购单" :value="0"></el-option>
              <el-option label="OEM大货单" :value="1"></el-option>
              <el-option label="OEM样品单" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="订单来源">
            <el-select v-model="formInline.systemSource" placeholder="来源" style="width:170px">
              <el-option label="全部" :value="''"></el-option>
              <el-option label="D2C" :value="1"></el-option>
              <el-option label="B2B" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="批次类型">
            <el-select v-model="formInline.pkgType" placeholder="包类型" style="width:170px">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="正品" value="1"></el-option>
              <el-option label="次品" value="2"></el-option>
              <el-option label="异常" value="3"></el-option>
              <el-option label="异常上报采购" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="库区" label-width="68px">
            <el-select v-model="formInline.actualRegionName" placeholder="库区列表" filterable style="width:168px">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="初检区" :value="'初检区'"></el-option>
              <div v-for="(item, index) in regionList" :key="index">
                <el-option :label="item.regionName" :value="item.regionName">
                </el-option>
                <el-option :label="item.regionName + '-交接区'" :value="item.regionName + '-交接区'">
                </el-option>
              </div>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="客户名称" label-width="68px">
            <el-input maxlength='50' placeholder="输入客户名称" v-model="formInline.customerName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="客户ID" label-width="68px">
            <el-input maxlength='50' @input="changCustomerId" placeholder="输入客户ID"
              v-model="formInline.customerId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="用户标记">
            <el-select v-model="formInline.customerTag" placeholder="全部" style="width:170px">
              <el-option label="全部" :value='undefined'></el-option>
              <el-option v-for="item in customerTagList" :label="item.tagName" :value='item.tag'
                :key="item.tag"></el-option>
              <!-- <el-option label="重点客户-非项目" :value='2'></el-option>
              <el-option label="重点新客" :value='4'></el-option>
              <el-option label="项目客户" :value='5'></el-option>
              <el-option label="重点客户" :value='6'></el-option>
              <el-option label="主动营销" :value='8'></el-option>
              <el-option label="被动营销" :value='9'></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="附加项" label-width="68px">
            <el-select v-model="formInline.additionCodeList" multiple placeholder="全部" filterable clearable
              collapse-tags style="width:170px">
              <el-option v-for="v in additionList" :key="v.additionCode" :label="v.additionName"
                :value='v.additionCode'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="组合商品">
            <el-select v-model="formInline.combinationProductItemFlag" placeholder="全部" clearable collapse-tags
              style="width:170px">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="组合子商品" :value="1"></el-option>
              <el-option label="非组合子商品" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="入库单号">
            <el-input maxlength='50' placeholder="输入入库单号" v-model="formInline.inboundCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="lg">
          <el-form-item label="平台SKU" label-width="68px">
            <div @dblclick="dblclick('productSkus')">
              <el-input maxlength='450' v-model="formInline.productSkus" placeholder="双击批量搜索"></el-input>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="xl">
          <el-form-item label="入库时间">
            <el-date-picker v-model="date" @change="dateChange" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="xl">
          <el-form-item label="">
            <el-select v-model="formInline.transferTimeType" placeholder="库区列表" filterable clearable
              style="margin-right:10px;width:140px" @change="transferTimeTypeChange">
              <el-option label="全部移库时间" :value="undefined"></el-option>
              <el-option label="移库质检房时间" :value="1"></el-option>
              <el-option label="移库成品区时间" :value="2"></el-option>
              <el-option label="移库次品区时间" :value="4"></el-option>
              <el-option label="移库异常区时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="transferDate" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              style="top:1px;" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss" @change="transferDateChange" clearable
              :disabled="!formInline.transferTimeType">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <el-radio-group v-model="frame">
              <el-radio :label="0" :hidden="true">今日</el-radio>
              <el-radio :label="1" @click.native.stop="about(1, $event)">今日</el-radio>
              <el-radio :label="2" @click.native.stop="about(2, $event)">近2天</el-radio>
              <el-radio :label="3" @click.native.stop="about(3, $event)">近3天</el-radio>
              <el-radio :label="5" @click.native.stop="about(5, $event)">近5天</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item v-if="prentType != 'small'">
            <el-checkbox :true-label="true" :false-label="false"
              v-model="formInline.packageSizeMeasure">包装尺寸待维护</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检索数量">
            <el-select v-model="formInline.numberType" placeholder="请选择" filterable clearable
              style="margin-right:10px;width:140px" @change="changeNumberType">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="剩余数量" value="remainAmount"></el-option>
            </el-select>
            <el-input style="margin-right:10px;width:240px" placeholder="请输入数量" :disabled="!formInline.numberType"
              v-model="formInline.number">
              <el-select style="width: 80px;" :disabled="!formInline.numberType" v-model="formInline.compareType"
                slot="prepend" placeholder="请选择">
                <el-option label="<" value="1"></el-option>
                <el-option label="=" value="2"></el-option>
                <el-option label=">" value="3"></el-option>
                <el-option label="<=" value="4"></el-option>
                <el-option label=">=" value="5"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item>
            <el-button style="" type="primary" @click="() => searchClick()">搜索</el-button>
            <el-button style="margin-left: 10px" @click="rest">重置</el-button>
            <el-button @click="print" type="primary">导出</el-button>
            <el-button @click="printCheck" type="primary">导出质检明细</el-button>
            <el-button @click="$refs.morePrintDialog.open({})" type="primary">批量打印</el-button>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <MorePrintDialog ref="morePrintDialog" @search="batchPrint" />
    <BatchSearchDialog ref="batchSearchDialog" @search="batchSearch" />
  </div>
</template>

<script>
import BatchSearchDialog from '@/components/BatchSearchDialog/index.vue'
import MorePrintDialog from './MorePrint.vue';
import { getAdditionList } from '@/apis/outStock'
import { listCustomerTasEnum } from "@/apis/auth"
export default {
  name: "From",
  components: { BatchSearchDialog, MorePrintDialog },
  data() {
    return {
      formInline: {},
      date: null,
      frame: null,
      transferDate: null,
      additionList: [],
      customerTagList: [],
      lg: 4,
      xl: 9,
    };
  },
  props: {
    regionList: {
      type: Array,
    },
  },
  mounted() {
    this.$emit("search", this.formInline);
    this.getAdditionList()
    this.lg = window.innerWidth < 1820 ? 6 : 4
    this.xl = window.innerWidth < 1820 ? 11 : 9
    window.addEventListener('resize', () => {
      this.lg = window.innerWidth < 1820 ? 6 : 4
      this.xl = window.innerWidth < 1820 ? 11 : 9
    })
    listCustomerTasEnum().then(res => {
      this.customerTagList = res.data ?? []
    })
  },
  methods: {
    batchPrint() { },
    searchClick(extraParams) {
      const params = {
        ...this.formInline,
        ...extraParams,
      }
      if (params.numberType && /\d+/.test(params.number)) {
        params[this.formInline.numberType] = Number(params.number)
      } else {
        params.numberType = undefined
        params.compareType = undefined
      }
      this.$emit("search", params);
    },
    changeNumberType(e) {
      if (!e) {
        this.formInline.number = undefined
        this.formInline.compareType = '5'
        this.formInline.numberType = undefined
        return
      }
    },
    async getAdditionList() {
      const data = await getAdditionList().then(res => res.data).catch(() => [])
      this.additionList = data ?? []
    },
    changCustomerId(val) {
      this.formInline.customerId = val?.replace(/[^\d]/g, '')
    },
    dateChange: function (date) {
      this.frame = -1
      if (!date) {
        console.log(!date)
        this.date = null;
        this.formInline.createTimeBegin = undefined;
        this.formInline.createTimeEnd = undefined;
        return;
      }
      this.formInline.createTimeBegin = date[0];
      this.formInline.createTimeEnd = date[1];
    },
    transferDateChange(date) {
      if (!date) {
        this.transferDate = null;
        this.formInline.transferTimeBegin = undefined;
        this.formInline.transferTimeEnd = undefined;
        return;
      }
      this.formInline.transferTimeBegin = date[0];
      this.formInline.transferTimeEnd = date[1];
    },
    transferTimeTypeChange(e) {
      console.log(e)
      if (e) {
        return
      }
      this.transferDateChange(null)
    },
    about(val, res) {
      if (res.target.tagName == "INPUT") {
        return false;
      }
      if (val == this.frame) {
        return false;
      }

      this.date = null;
      let endTime = new Date(
        new Date(new Date().getTime()).setHours(
          23,
          59,
          59,
          999
        )
      );
      let startTime = endTime - val * 86400000;
      this.formInline.createTimeBegin = formatDate(startTime);
      this.formInline.createTimeEnd = formatDate(endTime);
      this.$emit("search", this.formInline);
      function formatDate(value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
    rest() {
      this.formInline = {
        compareType: '5',
        packageSizeMeasure: false
      };
      this.date = null;
      this.frame = -1
      this.formInline.createTimeBegin = undefined;
      this.formInline.createTimeEnd = undefined;
      this.$emit("search", this.formInline);
    },
    print() {
      this.$emit('print')
    },
    printCheck() {
      this.$emit('printCheck')
    },
    dblclick(key) {
      this.$refs.batchSearchDialog.open({ key })
    },
    batchSearch(params) {
      this.searchClick(params)
    }
  },
};
</script>

<style scoped>
::v-deep .el-form-item__label {
  white-space: nowrap;
}
</style>
